import {
  Button,
  Table,
  Typography,
  Form,
  Space,
  Row,
  Upload,
  Tooltip,
} from "antd";
import React, {SetStateAction, useEffect, useState} from "react";
import {EditableCell, EditableRow} from "./EditTable";
import Icons from "assets/icons";
import {ColumnTypes} from "types/models/column-table-edit";
import "./TableInputAdd.scss";
import {exportFile, randomId} from "helper/common";
import {shoppingService} from "api";
import {ListActionButton, Notification} from "components/common";
import TableCustom from "components/common/TableCustom/TableCustom";

const TableInputAdd = ({
  data,
  column,
  setData,
  isCheckbox,
  disabled,
  name,
  form,
  setTongTien,
  setIdSelectedItem,
  isViewHistoryPay,
  ...rest
}: any): JSX.Element => {
  const addRowTb1 = () => {
    const newData = {
      key: randomId(),
    };
    setData([...data, newData]);
  };
  const listActionButton = (value, record, index) => {
    return (
      <ListActionButton
        showDetailFunction={
          record?.id && isViewHistoryPay
            ? () => {
                setIdSelectedItem(record?.id);
              }
            : undefined
        }
      >
        <Button
          disabled={disabled}
          type="primary"
          danger
          onClick={() => {
            removeRowTb1(record?.key);
            setTongTien();
          }}
          icon={<Icons.sub />}
          size="small"
        />
      </ListActionButton>
    );
  };
  column.some((item: any) => {
    if (item.key == "action") {
      item.title = (
        <Button
          disabled={disabled}
          type="primary"
          onClick={addRowTb1}
          icon={<Icons.add />}
          size="small"
        />
      );
      item.fixed = "right";
      // item.render = (_: any, record: {key: string}, index: number) => (
      //   <Space>
      //     {/* <Tooltip title="Tải lên">
      //       <Upload
      //         accept="application/pdf"
      //         beforeUpload={file => {
      //           handleUpload(file, index);
      //           return false;
      //         }}
      //         fileList={[]}
      //       >
      //         <Button
      //           onClick={() => {}}
      //           type="primary"
      //           icon={<Icons.upload></Icons.upload>}
      //         ></Button>
      //       </Upload>
      //     </Tooltip>
      //     <Tooltip title="Tải xuống">
      //       <Button
      //         type="primary"
      //         icon={<Icons.download></Icons.download>}
      //         onClick={() => {
      //           handleDownloadFile(index);
      //         }}
      //       ></Button>
      //     </Tooltip> */}

      //     <Button
      //       disabled={disabled}
      //       type="primary"
      //       danger
      //       onClick={() => {
      //         removeRowTb1(record?.key);
      //         setTongTien();
      //       }}
      //       icon={<Icons.sub />}
      //       size="small"
      //     />
      //   </Space>
      // );
    }
  });
  // const handleUpload = async (file, index) => {
  //   try {
  //     const formData = new FormData();
  //     formData.append("file", file);
  //     const res = await shoppingService.uploadChungTu(formData);
  //     form.setFieldValue(
  //       [name, index, "ktchungTu"],
  //       file?.name ?? "Đã tải chứng từ"
  //     );
  //     form.setFieldValue([name, index, "file"], res?.fileId);
  //   } catch (error) {}
  // };
  // const handleDownloadFile = async index => {
  //   try {
  //     const file = form.getFieldValue([name, index, "file"]);
  //     const ktchungTu = form
  //       .getFieldValue([name, index, "ktchungTu"])
  //       .replace(".pdf", "");
  //     await exportFile(
  //       "qlttbhyt-service/download-files",
  //       {file: file},
  //       ktchungTu,
  //       "pdf"
  //     );
  //   } catch (error) {
  //     Notification("error", error?.response?.data ?? "Có lỗi khi tải chứng từ");
  //   }
  // };
  const removeRowTb1 = (key: string) => {
    const previousFormList = form.getFieldValue([name]);

    const indexRemove = data.findIndex((e: any) => e?.key == key);
    const afterFormList = previousFormList.filter(
      (e: any, index: number) => index != indexRemove
    );
    form.setFieldValue([name], afterFormList);
    const newData = data.filter((item: any) => item.key != key);
    setData([...newData]);
  };

  const handleSave = (row: any, index: number) => {
    const newData = data.map((e: any) => ({...e, key: randomId()}));
    newData[index] = row;
    setData(newData);
  };

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };

  const columns = column
    .filter((e: any) => e.show == true)
    .map((col: any) => {
      return {
        ...col,
        onCell: (record: any, index: number) => ({
          record: data[index],
          selected: col.selected,
          dataIndex: col.dataIndex,
          title: col.title,
          options: col.options,
          onChange: col.onChange,
          index: index,
          handleSave,
          type: col.type,
          disabled: col.disabled ?? disabled,
          value: col.value,
          name: name,
          form: form,
          initRules: col.rules,
          autoFocus: col.autoFocus,
          fields: col.fields,
          hidden: col.hidden,
          setTongTien: setTongTien,
          ...col,
        }),
      };
    });
  console.log(columns);
  useEffect(() => {}, [data]);
  return (
    <div className="table-prescription">
      <TableCustom
        rowKey={record => record.key}
        components={components}
        rowClassName={"editable-row-2"}
        bordered
        dataSource={data}
        columns={columns as ColumnTypes}
        {...rest}
        pagination={false}
        listActionButton={listActionButton}
      />
      {/* {data && columnsInit && components && (
        <Form form={form}>
          <Form.Item name={"table"}></Form.Item>
        </Form>
      )} */}
    </div>
  );
};

export default TableInputAdd;
